import { useTypeDefinition } from './type-definition-context';
export const TypeDefinitionIndent = () => {
  const {
    indent = 0,
    language
  } = useTypeDefinition();
  let char = ' ';
  let size = 2;
  if (['dotnet', 'java', 'php', 'python'].includes(language)) {
    size = 4;
  }
  if (language === 'go') {
    size = 1;
    char = '\t';
  }
  return <>{char.repeat(indent * size)}</>;
};